import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useParams } from 'react-router-dom';
import Dashboard from './components/Dashboard';
import RemoveRolePage from './components/RemoveRolePage';
import ApprovalPage from './components/ApprovalPage';
import RejectionPage from './components/RejectionPage';
import ApprovalSuccessPage from './components/ApprovalSuccessPage';
import LoginPage from './components/LoginPage';
import ProtectedRoute from './components/ProtectedRoute';
import './App.css';

// Component to handle backward compatibility redirects
const ApproveRedirect = () => {
  const { requestId } = useParams();
  return <Navigate to={`/request/approve/${requestId}`} replace />;
};

const RejectRedirect = () => {
  const { requestId } = useParams();
  return <Navigate to={`/request/reject/${requestId}`} replace />;
};

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/roles/remove" element={<ProtectedRoute><RemoveRolePage /></ProtectedRoute>} />
          {/* New routes */}
          <Route path="/request/approve/:requestId" element={<ApprovalPage />} />
          <Route path="/request/reject/:requestId" element={<RejectionPage />} />
          {/* Handle backend-generated approval URLs */}
          <Route path="/request/:requestId" element={<ApprovalPage />} />
          <Route path="/approval-success" element={<ApprovalSuccessPage />} />
          {/* Backward compatibility routes for existing email links */}
          <Route path="/approve/:requestId" element={<ApproveRedirect />} />
          <Route path="/reject/:requestId" element={<RejectRedirect />} />
          {/* Catch-all route - redirect to dashboard for any unmatched routes */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
